import { rankStageImage } from '../common/rankArtwork';
import { fantasyGuildImage } from './guildImages';
import { Beer, Swords, Castle, Crown, Wand2, Gavel, Gem } from 'lucide-react';
import logo from '../../assets/goodvale_logo.png';
import wordmark from '../../assets/goodvale_wordmark.png';
import de from './de.json';
import en from './en.json';
import { CLASS_ICONS, TALENT_ICONS, CATEGORY_ICONS, ROLE_ICONS } from './icons';
import { CLASS_SCENES_DARK, CLASS_SCENES_LIGHT } from './scenes';
import errorImage from '../../assets/wanderer_resting.jpg';
export default {
  messages: { de, en },
  featureIcons: { news:Beer, action:Swords, group:Castle, trust:Crown, benefits:Wand2, review:Gavel, engagement:Crown, points:Gem },
  ornamentation: 'decorative',
  logo, wordmark,
  icon: (kind, key) => ({class:CLASS_ICONS,talent:TALENT_ICONS,category:CATEGORY_ICONS,role:ROLE_ICONS,illustration:{TREASURY:TALENT_ICONS.B_TREASURE_HUNTER,PROGRESS:TALENT_ICONS.A_HEROIC_ACTION_SPONSOR,PROOF:TALENT_ICONS.B_VERIFIED_PROOF}}[kind]?.[key] || CLASS_ICONS.SCOUT),
  scene: (key, theme) => (theme === 'light' ? CLASS_SCENES_LIGHT : CLASS_SCENES_DARK)[({NEWS:'SOCIAL',ACTION:'GUARDIAN',GROUPS:'SCOUT',BENEFITS:'TECH',EVENTS:'SOCIAL',PROGRESS:'MEDIC',MAP:'SCOUT',REVIEW:'GUARDIAN'}[key] || key)] || CLASS_SCENES_DARK.SCOUT,
  guildImage: fantasyGuildImage,
  errorImage,
  stageImage: rankStageImage,
  preview: CLASS_SCENES_LIGHT.TECH,
  flyer: (audience, language) => '/downloads/goodvale-'+(audience==='adventurer'?'abenteurer':'partner')+'-flyer'+(language==='en'?'-en':''),
};
